import { Alert } from '@mui/material';
import FormSRT from './FormSRT';
import { useRoles } from '../../../hooks/useRoles';

const ESTADO_SRT_EN_PROCESO = 2;

interface SiniestroSrtTabProps {
    siniestro?: any;
}

function SiniestroSrtTab({ siniestro }: SiniestroSrtTabProps) {
    const isBlocked = siniestro?.estadoSrt === ESTADO_SRT_EN_PROCESO;
    const { isSupervisorSIMP } = useRoles();

    return (
        <>
            {isBlocked && !isSupervisorSIMP && (
                <Alert severity="info" sx={{ mb: 3 }}>
                    El preventor está completando el formulario de investigación. La edición estará
                    disponible cuando se apruebe la visita.
                </Alert>
            )}
            <FormSRT
                siniestro={siniestro}
                overrides={
                    isSupervisorSIMP
                        ? { readOnly: true, ocultarTxt: true, pdfEnSoloLectura: true }
                        : isBlocked
                          ? { readOnly: true }
                          : undefined
                }
            />
        </>
    );
}

export default SiniestroSrtTab;
